<script>
import BasePopup from '../../BasePopup.vue';
import BaseInput from '../../BaseInput.vue';
import UserTile from '../../UserTile.vue';

export default {
  name: 'TaskViewMembersPopup',
  components: { BasePopup, BaseInput, UserTile },
  props: {
    value: Object,
    multiple: Boolean,
    users: Array,
    header: String,
    action: String,
    mode: String,
  },
  data() {
    return {
      searchString: '',
    };
  },
  computed: {
    usersFiltered() {
      return (this.users ?? []).filter((user) => {
        const searchString = this.searchString.toLowerCase();

        const fitsBySearchString = searchString === ''
          || user.name.toLowerCase().includes(searchString)
          || user.surname.toLowerCase().includes(searchString)
          || user.email.toLowerCase().includes(searchString);

        return fitsBySearchString;
      });
    },

    buttonText() {
      if (!this.value.selectedUsers.length && this.action === 'members' && this.mode === 'set') {
        return 'Удалить наблюдателей';
      }

      if (!this.value.selectedUser && this.action === 'manager') {
        return 'Удалить исполнителя';
      }

      return 'Сохранить';
    },

    isButtonDisabled() {
      let res = false;

      if (this.action === 'author') {
        res = !this.value.selectedUser === true;
      }

      if (this.action === 'members' && this.mode === 'add') {
        res = this.value.selectedUsers.length === 0;
      }

      return res;
    },

    message() {
      let message = null;

      if (this.action === 'members' && this.mode === 'set' && this.value.selectedUsers.length) {
        message = 'Текущие наблюдатели в выбранных задачах будут заменены';
      }

      return message;
    },
  },
  methods: {
    isSelected(user) {
      return this.multiple
        ? this.value?.selectedUsers.includes(user['@id'])
        : this.value?.selectedUser === user['@id'];
    },
  },
};
</script>

<template lang="pug">
BasePopup(@close="$emit('submit', false)" :zIndex="9000")
  .b-user-select-popup
    h2._title {{ header }}
    BaseInput(v-model="searchString" label="Поиск")
    ._message(v-if="message") {{ message }}
    ._users
      ._user(v-for="user in usersFiltered")
        UserTile(:user="user")
        ._status
          Btn(sm grey transparent v-if="isSelected(user)" @click="$emit('change', user)") Отменить
          Btn(sm green v-else @click="$emit('change', user)") Выбрать
    ._buttons
      Btn(:disabled="isButtonDisabled" @click="$emit('submit', true)") {{ buttonText }}
      Btn(@click="$emit('submit', false)" grey) Отмена
</template>

<style scoped lang="scss">
.user-select-popup {
  width: 450px;
  max-width: 100%;
  display: flex;
  flex-direction: column;
  gap: 20px;

  &__title {
    font-size: 24px;
    line-height: 24px;
    color: var(--color-super-dark);
  }

  &__users {
    overflow-y: scroll;
    overflow-x: hidden;
    display: flex;
    flex-direction: column;
    gap: 13px;
    max-height: calc(100vh - 370px);
    padding-bottom: 7px;
  }

  &__user {
    display: flex;
    gap: 17px;
  }

  &__status {
    margin-left: auto;
    width: 150px;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  &__selected {
    font-size: 12px;
    line-height: 15px;
    letter-spacing: 0.01em;
    color: #788CA1;
    font-weight: normal;
  }

  &__buttons {
    display: flex;
    justify-content: flex-end;
    gap: 20px;
  }

  &__message {
    color: rgb(241, 114, 117);
    font-family: Geometria, sans-serif;
    font-size: 12px;
    font-weight: 500;
    line-height: 15px;
    letter-spacing: normal;
    text-align: left;
  }
}
</style>
